// recentContractGroups.js — 상황판 '최근 계약' 위젯의 날짜 묶기 (2026-10-19, useSituationStats 에서 옮김)
//   본사 위젯(본사 계약 목록)과 회사별·통합 계약 위젯(그 화면의 계약 목록)이 같은 묶기를 쓴다.
//   모바일 상단 최근 계약: 오늘 + 가장 최근 과거 날짜 (계약 있는 날) 2개 표시
import { toDateOnlyUtc } from '../../../utils/date';

/**
 * @param {object[]} contracts 계약 목록(취소 포함 — 여기서 뺀다)
 * @param {string} today 'YYYY-MM-DD'(KST)
 * @returns {{date:string,label:string,contracts:object[]}[]}
 */
export function groupRecentContracts(contracts, today) {
  const active = (contracts || []).filter((r) => r.contract_status !== 'cancelled');
  // 날짜별 그룹핑
  const byDate = {};
  active.forEach((r) => {
    const dt = (r.contract_date || r.visit_date || '').slice(0, 10);
    if (!dt) return;
    if (!byDate[dt]) byDate[dt] = [];
    byDate[dt].push(r);
  });
  const result = [];
  // 첫 번째: 오늘 계약
  result.push({ date: today, label: '오늘 계약', contracts: byDate[today] || [] });
  // 두 번째: 어제부터 과거로 탐색, 계약이 있는 첫 번째 날
  const pastDates = Object.keys(byDate).filter((d) => d < today).sort((a, b) => b.localeCompare(a));
  if (pastDates.length > 0) {
    const d = pastDates[0];
    // toDateOnlyUtc: utils/date.js 사용 (new Date 직접 사용 금지)
    const diffDays = Math.round((toDateOnlyUtc(today) - toDateOnlyUtc(d)) / 86400000);
    const label = diffDays === 1 ? '어제 계약' : diffDays === 2 ? '그저께 계약' : `${diffDays}일 전 계약`;
    result.push({ date: d, label, contracts: byDate[d] });
  }
  return result;
}
